import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './styles.module.scss';
import { LocaleContext } from '../../Banner';

const Headline = ({ children, headlineLevel, headlineStyle }) => {
  const { dataJurisdiction, headlineAsSpan } = useContext(LocaleContext);

  const Tag = headlineAsSpan ? 'span' : `h${headlineLevel}`;

  return (
    <Tag
      style={headlineStyle}
      data-jurisdiction={dataJurisdiction}
      className={cn(styles.title, styles[`headline-${headlineLevel}`])}
      data-testid={`h${headlineLevel}`}
    >
      {children}
    </Tag>
  );
};

Headline.defaultProps = {
  headlineLevel: 1,
  headlineStyle: {},
};

Headline.propTypes = {
  headlineLevel: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
  headlineStyle: PropTypes.oneOfType([PropTypes.object]),
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.element]).isRequired,
};

export default Headline;
